import { Outlet } from "react-router-dom";

import styles from "./Root.module.css";
import { Box, VStack } from "@chakra-ui/react";

const RootLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default RootLayout;
